module.exports = "/packs/011-1d6122452a29c237d705f0703bffce48.jpg";